import React from 'react';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

import { investmentTransactionEditFormHooks } from 'components/Forms/InvestmentTransactionEditForm/investmentTransactionEditFormHooks';
import { SecurityAndTagsFields } from './SecurityAndTagsFields';
import { handleNumericKeyDown, useNumericTextField } from './utils';

export function UnitsOnlyFields({ label, sign }: { label: string; sign: 1 | -1 }): React.JSX.Element {
  const units = investmentTransactionEditFormHooks.useField('units');
  const unitsInput = useNumericTextField({ value: units.value, onValueChange: units.onValueChange, sign });

  return (
    <>
      <SecurityAndTagsFields />
      <Box display='flex' alignItems='center' gap={1}>
        <TextField
          id='units'
          label={label}
          type='number'
          inputProps={{ min: 1, inputMode: 'decimal' }}
          sx={{ minWidth: 110 }}
          value={unitsInput.value}
          onKeyDown={handleNumericKeyDown}
          onChange={unitsInput.onChange}
          error={units.error}
          helperText={
            units.helperText || (label === 'Shares quantity' ? 'Total shares received for each shares held' : '')
          }
        />
      </Box>
    </>
  );
}
